import states from "@cxm/ui/utils/states";
import z from "zod";
import { PortalType } from "@cxm/client";

export const stateOptions = states.map((state) => ({
  label: state.name,
  value: state.abbreviation,
}));

export const fileModel = z.object({
  Id: z.string(),
  Name: z.string(),
});

export const userModel = z.object({
  id: z.number(),
  email: z.string(),
  firstname: z.string(),
  lastname: z.string(),
});

export const addressModel = z.object({
  line1: z.string().nullish(),
  line2: z.string().nullish(),
  zipCode: z.string().nullish(),
  state: z.string().nullish(),
  city: z.string().nullish(),
});

export const portalLink = (type: PortalType) => {
  switch (type) {
    case PortalType.BORROWER:
      return "/borrower";
    case PortalType.LENDER:
      return "/lender";
    case PortalType.MANAGEMENT:
      return "/specialist";
  }
};

export const portalColor = (type: PortalType) => {
  switch (type) {
    case "Borrower":
      return "hsl(var(--primary))";
    case "Lender":
      return "#FFA500";
    case "Management":
      return "#000000";
  }
};

export const portalName = (type: PortalType) => {
  switch (type) {
    case "Borrower":
      return "Borrower";
    case "Lender":
      return "Lender";
    case "Management":
      return "Specialist";
  }
};

export const ApiBaseUrl = process.env.NEXT_PUBLIC_BASE_API_URL ??
  process.env.REACT_APP_BASE_API_URL;

export const PortalTypeNumber = (val: number): PortalType => {
  switch (val) {
    case 0:
      return "Management";
    case 1:
      return "Lender";
    case 2:
      return "Borrower";
    default:
      return "Borrower";
  }
};
